/**
 * Using regexp to remove all the HTML inside the string
 * and checking if the string contains only white space
 *
 * @param {string} input
 * @return {boolean}
 *  */

const isEmptyAfterHTMLClean = (input: string): boolean =>
  Boolean(!input?.replace(/<[^>]+>/g, '')?.replace(/\s/g, '')?.length)

export default isEmptyAfterHTMLClean
